module.exports = __webpack_public_path__ + "img/machine-icon.de6e276e.svg";